import { LocalStorage } from 'src/utils/LocalStorage'
import { PATH as PATH_USER_DETAIL } from 'src/pages/myPage/UserDetail'
import { PATH as PATH_MY_PAGE } from 'src/pages/myPage'
import { AddressByPostalCodeInterface } from './../interfaces/address.d'
import { UseFormReturn } from 'react-hook-form/dist/types/form'
import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  UpdateAddressRequestInterface,
  verifyOTPRequestInterface,
} from 'src/interfaces/address'
import { AddressByPostalCodeRequestInterface } from 'src/interfaces/address'
import addressRequest from 'src/api/requests/address'
import addressActions from 'src/store/domain/address/addressByPostalCode'
import addressDeliveryActions from 'src/store/domain/address/addressDeliveryByPostalCode'
import uiActions from 'src/store/ui/notification'
import { HTTP_CODE, PLAN_TYPE } from 'src/constants/app'
import history from 'src/libs/history'
import { PATH as AUTOMATIC_PLAN_PATH } from 'src/pages/automaticPlan'
import { get, includes as lodashIncludes } from 'lodash'
import { PATH as PATH_CHAT } from 'src/pages/chat/Chat'
import { getInfo } from './user'
import userRequest from 'src/api/requests/user'
import appActions from 'src/store/ui/app'
import { PATH as AUTH_PATH } from 'src/pages/auth'
import { PATH as PATH_VIDEO } from 'src/pages/video'
import { USER_TREATMENT_STATE } from 'src/enum/userTreatmentState'
import { PATH as PATH_REGULAR } from 'src/pages/regular'
import { PATH as PATH_KARTE_PLAN_PATH } from 'src/pages/kartePlan'
import { updatePlanSelection, createUserTreatment } from './userTreatment'

export const getAddressByPostalCode = createAsyncThunk<
  any,
  AddressByPostalCodeRequestInterface
>(
  'get_address_by_postal_code',
  async ({ postal_code, isPaymentPage }, { dispatch }) => {
    try {
      dispatch(addressActions.updateLoading(true))
      const res = await addressRequest.getAddressByPostalCode({ postal_code })
      if (res.data) {
        dispatch(addressActions.updateEntity(res.data))
      }
      dispatch(addressActions.updateLoading(false))
      return res?.data
    } catch (error: any) {
      const message = error?.response?.data.message
      const defaultValue: AddressByPostalCodeInterface = {
        address1: '',
        address2: '',
        address3: '',
      }
      dispatch(addressActions.updateLoading(false))
      dispatch(addressActions.updateEntity(defaultValue))
      if (!isPaymentPage) {
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message: message,
          }),
        )
      }
    }
  },
)

export const getAddressDeliveryByPostalCode = createAsyncThunk<
  any,
  AddressByPostalCodeRequestInterface
>(
  'get_address_delivery_by_postal_code',
  async ({ postal_code }, { dispatch }) => {
    try {
      dispatch(addressDeliveryActions.updateLoading(true))
      const res = await addressRequest.getAddressByPostalCode({
        postal_code,
      })
      if (res.data) {
        dispatch(addressDeliveryActions.updateEntity(res.data))
      }
      dispatch(addressDeliveryActions.updateLoading(false))
    } catch (error: any) {
      const message = error?.response?.data.message
      const defaultValue: AddressByPostalCodeInterface = {
        address1: '',
        address2: '',
        address3: '',
      }
      dispatch(addressDeliveryActions.updateLoading(false))
      dispatch(addressDeliveryActions.updateEntity(defaultValue))
      dispatch(
        uiActions.onNotification({
          type: 'error',
          message: message,
        }),
      )
    }
  },
)

export interface PostAddress {
  credentials: UpdateAddressRequestInterface
  meta: UseFormReturn<UpdateAddressRequestInterface, any>
  planType?: string
}

export interface PostAddressDelivery {
  credentials: Pick<
    UpdateAddressRequestInterface,
    'postal_number' | 'address' | 'building_name' | 'city_id' | 'prefecture_id'
  >
  meta: UseFormReturn<UpdateAddressRequestInterface, any>
}

export interface PutAddressDelivery {
  credentials: Pick<
    UpdateAddressRequestInterface,
    'postal_number' | 'address' | 'building_name' | 'city_id' | 'prefecture_id'
  >
  address_id: number
  meta: UseFormReturn<UpdateAddressRequestInterface, any>
}

export const updateAddress = createAsyncThunk<any, PostAddress>(
  'update_address',
  async ({ credentials, meta }, { dispatch }) => {
    try {
      dispatch(addressActions.updateLoading(true))
      await addressRequest.updateAddress(credentials)
      dispatch(addressActions.updateLoading(false))
      if (credentials?.isIgnoreSms) {
        history.push(AUTOMATIC_PLAN_PATH.IDENTIFICATION)
      } else {
        history.push(AUTOMATIC_PLAN_PATH.SMS_AUTH)
      }
    } catch (error: any) {
      const status = error?.response?.status
      const errors = error?.response?.data.errors

      if (
        status === HTTP_CODE.UNPROCESSABLE_ENTITY &&
        Object.entries(errors).length > 0
      ) {
        errors &&
          Object.entries(errors).map((value) => {
            const getFieldName = get(value, 0)
            const getFieldValue = get(value, '1.0') || ''

            meta.setError(
              getFieldName as
                | 'postal_number'
                | 'prefecture_id'
                | 'city_id'
                | 'address'
                | 'building_name'
                | 'phone'
                | 'email'
                | 'password',
              { type: 'custom', message: getFieldValue },
            )
          })
      } else {
        const message = error?.response?.data.message
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message: message,
          }),
        )
      }
      dispatch(addressActions.updateLoading(false))
      throw error
    }
  },
)

export const createAddressDelivery = createAsyncThunk<any, PostAddressDelivery>(
  'address-delivery',
  async ({ credentials, meta }, { dispatch }) => {
    try {
      dispatch(addressActions.updateLoading(true))
      await addressRequest.createAddressDelivery(credentials)
      dispatch(addressActions.updateLoading(false))
    } catch (error: any) {
      const status = error?.response?.status
      const errors = error?.response?.data.errors

      if (
        status === HTTP_CODE.UNPROCESSABLE_ENTITY &&
        Object.entries(errors).length > 0
      ) {
        errors &&
          Object.entries(errors).map((value) => {
            const getFieldName = get(value, 0)
            const getFieldValue = get(value, '1.0') || ''

            meta.setError(
              getFieldName as
                | 'postal_number'
                | 'prefecture_id_delivery'
                | 'city_id_delivery'
                | 'address_delivery',
              { type: 'custom', message: getFieldValue },
            )
          })
      } else {
        const message = error?.response?.data.message
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message: message,
          }),
        )
      }
      dispatch(addressActions.updateLoading(false))
      throw error
    }
  },
)

export interface PostOTP {
  credentials: verifyOTPRequestInterface
  meta: UseFormReturn<verifyOTPRequestInterface, any>
  planType: string
  menu_id?: string | number
}

export const verifyOTP = createAsyncThunk<any, PostOTP>(
  'verify_otp',
  async ({ credentials, meta, planType, menu_id }, { dispatch }) => {
    try {
      dispatch(addressActions.updateLoading(true))
      const userTreatmentId = LocalStorage.getUserTreatmentId()

      await addressRequest.verifyOTP({
        ...credentials,
        ...{ plan_type: planType, user_treatment_id: userTreatmentId },
      })

      const resInitial = await userRequest.userInfo({
        with: 'userTreatments.lastDoctorFeedback,clinics',
      })

      dispatch(appActions.updateAuthInfo(resInitial.data))

      let currentTreatment = resInitial.data?.user_treatments?.find(
        (ut: any) =>
          userTreatmentId &&
          ut.id === Number(userTreatmentId) &&
          menu_id &&
          ut.menu_id === Number(menu_id),
      )

      let finalUserTreatmentId = userTreatmentId || currentTreatment?.id

      if (!finalUserTreatmentId && menu_id) {
        const createRes = await dispatch(
          createUserTreatment({
            data: { menu_id: Number(menu_id) },
            form: meta as any,
          }),
        ).unwrap()
        finalUserTreatmentId = createRes?.id
        currentTreatment = createRes
      }

      if (!finalUserTreatmentId) {
        return history.push(PATH_USER_DETAIL)
      }

      LocalStorage.setUserTreatmentId(String(finalUserTreatmentId))

      // const planId = LocalStorage.activePlan || currentTreatment?.plan_id
      const statesToTriggerUpdate = [USER_TREATMENT_STATE.REGISTERED_INTERVIEW]
      const shouldUpdatePlan = lodashIncludes(
        statesToTriggerUpdate,
        currentTreatment?.state,
      )

      let finalTreatment = currentTreatment

      if (shouldUpdatePlan) {
        finalTreatment = await dispatch(
          updatePlanSelection({
            id: Number(finalUserTreatmentId),
          }),
        ).unwrap()
      }

      let clinics = resInitial.data?.clinics

      if (!finalTreatment) {
        const res = await userRequest.userInfo({
          with: 'userTreatments,clinics',
        })

        dispatch(appActions.updateAuthInfo(res.data))

        finalTreatment = res.data?.user_treatments?.find(
          (ut: any) => ut.id === Number(finalUserTreatmentId),
        )
        clinics = res.data?.clinics
      }

      const menuId = menu_id || finalTreatment?.menu_id || ''
      const treatmentTele = finalTreatment?.telemedicine_enabled
      const telemedicineEnabled =
        treatmentTele == 2 ||
        (treatmentTele != 1 && !!clinics?.[0]?.telemedicine_enabled)

      LocalStorage.setTelemedicine(telemedicineEnabled ? 'true' : 'false')
      dispatch(addressActions.updateLoading(false))

      const treatmentStateAfterVerify = finalTreatment?.state
      if (
        treatmentStateAfterVerify ===
        USER_TREATMENT_STATE.SUBSCRIPTION_SUGGESTIONS
      ) {
        return history.push(AUTOMATIC_PLAN_PATH.SUGGEST_SUBSCRIPTION)
      }
      if (
        treatmentStateAfterVerify ===
          USER_TREATMENT_STATE.VIDEO_INTERVIEW_SCHEDULED &&
        !telemedicineEnabled
      ) {
        // [SCOPE] Guard added to match develop fix (9dd12b5d): telemedicine users in
        // VIDEO_INTERVIEW_SCHEDULED must fall through to the telemedicineEnabled block
        // below so LocalStorage.videoSchedule?.pending routing is evaluated correctly.
        return history.push(`${PATH_VIDEO.VIDEO_SCHEDULE}?menu_id=${menuId}`)
      }

      if (telemedicineEnabled) {
        const state = finalTreatment?.state

        // VIDEO_INTERVIEW_DATE = appointment date just selected but not yet confirmed.
        // User should land on the confirmation screen, not my page (Case 4 fix).
        if (state === USER_TREATMENT_STATE.VIDEO_INTERVIEW_DATE) {
          return history.push(
            `${PATH_VIDEO.TEMPORARY_RESERVE_CONFIRM}?menu_id=${menuId}`,
          )
        }

        // [SCOPE] On first-time video scheduling, the user is sent to SMS auth
        // before createReservationDate is called, so the treatment state is
        // still 'selected_treatment' / 'appointment_pending_questions' when OTP
        // completes. Without this check, verifyOTP would redirect to Questions
        // instead of the confirm page, and the reservation API would never fire.
        // We check pending:true (set by useSchedule.ts) to distinguish this
        // entry from the CONFIRMED_RESERVATION entry written by keepFlow.ts
        // (which has no pending field and is never cleaned up), preventing a
        // stale-key redirect for users who already have a confirmed reservation.
        if (LocalStorage.videoSchedule?.pending === true) {
          return history.push(
            `${PATH_VIDEO.TEMPORARY_RESERVE_CONFIRM}?menu_id=${menuId}`,
          )
        }

        if (
          lodashIncludes(
            [
              USER_TREATMENT_STATE.SELECTED_TREATMENT,
              USER_TREATMENT_STATE.APPOINTMENT_PENDING_QUESTIONS,
            ],
            state,
          )
        ) {
          return history.push(
            `${AUTOMATIC_PLAN_PATH.QUESTIONS.replace(':id', menuId || '')}`,
          )
        }

        return history.push(
          `${PATH_VIDEO.TEMPORARY_RESERVE_CONFIRM}?menu_id=${menuId}`,
        )
      } else {
        switch (finalTreatment?.state) {
          case USER_TREATMENT_STATE.CONFIRMING_PRESCRIPTION:
            return history.push(
              PATH_KARTE_PLAN_PATH.PRESCRIPTION_PROPOSAL.replace(
                ':id',
                finalTreatment.last_doctor_feedback?.id,
              ),
            )

          case USER_TREATMENT_STATE.CHAT_INTERVIEW_SCHEDULED:
          case USER_TREATMENT_STATE.CHAT_CONSULTATION_IN_PROGRESS:
            return history.push(PATH_CHAT)

          case USER_TREATMENT_STATE.DIRECT_PLAN_ELIGIBLE:
            return history.push(
              `${PATH_REGULAR.REGULAR_SUBSCRIPTION}?menu_id=${menuId}`,
            )

          case USER_TREATMENT_STATE.AWAITING_PLAN:
            return history.push(
              AUTOMATIC_PLAN_PATH.FINAL_QUESTIONS.replace(
                ':id',
                String(menuId),
              ),
            )
          case USER_TREATMENT_STATE.SELECTED_TREATMENT:
            return history.push(
              `${AUTOMATIC_PLAN_PATH.QUESTIONS.replace(':id', menuId || '')}`,
            )

          default:
            return history.push(PATH_MY_PAGE.TREATMENT_PATH)
        }
      }
    } catch (error: any) {
      const status = error?.response?.status
      const message = error?.response?.data.message

      if (status === HTTP_CODE.BAD_REQUEST) {
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message: message,
          }),
        )
      }
      dispatch(addressActions.updateLoading(false))
    }
  },
)

export const resendOTP = createAsyncThunk<any>(
  'resend_otp',
  async (prams, { dispatch }) => {
    try {
      dispatch(addressActions.updateLoading(true))
      await addressRequest.resendOTP()
      dispatch(addressActions.updateLoading(false))
      dispatch(
        uiActions.onNotification({
          type: 'success',
          message: '認証コードを再発行しました',
        }),
      )
    } catch (error: any) {
      const status = error?.response?.status
      const message = error?.response?.data.message

      if (status === HTTP_CODE.BAD_REQUEST) {
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message: message,
          }),
        )
      }

      dispatch(addressActions.updateLoading(false))
    }
  },
)

export const updateAddressSkipSMS = createAsyncThunk<any, PostAddress>(
  'update_address_skip_sms',
  async ({ credentials, meta, planType }, { dispatch }) => {
    try {
      dispatch(addressActions.updateLoading(true))
      await addressRequest.updateAddress(credentials)
      dispatch(addressActions.updateLoading(false))
      dispatch(
        getInfo({
          with: 'reservations,card,stateTransitions,cycleOrderPaid,latestOrderCanPay',
        }),
      )
      if (planType === PLAN_TYPE.PRESCRIPTION) {
        history.push(AUTH_PATH.REGISTRATION_COMPLETE)
      } else {
        history.push(
          credentials.isIgnoreSms
            ? PATH_USER_DETAIL
            : AUTOMATIC_PLAN_PATH.SMS_AUTH,
        )
      }
    } catch (error: any) {
      const status = error?.response?.status
      const errors = error?.response?.data.errors
      if (
        status === HTTP_CODE.UNPROCESSABLE_ENTITY &&
        Object.entries(errors).length > 0
      ) {
        errors &&
          Object.entries(errors).map((value) => {
            const getFieldName = get(value, 0)
            const getFieldValue = get(value, '1.0') || ''

            meta.setError(
              getFieldName as
                | 'postal_number'
                | 'prefecture_id'
                | 'city_id'
                | 'address'
                | 'building_name'
                | 'phone'
                | 'email',
              { type: 'custom', message: getFieldValue },
            )
          })
      } else {
        const message = error?.response?.data.message
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message: message,
          }),
        )
      }
      dispatch(addressActions.updateLoading(false))
    }
  },
)

export const updateAddressDelivery = createAsyncThunk<any, PutAddressDelivery>(
  'address-delivery',
  async ({ credentials, address_id, meta }, { dispatch }) => {
    try {
      dispatch(addressActions.updateLoading(true))
      await addressRequest.updateAddressDelivery(credentials, address_id)
      dispatch(addressActions.updateLoading(false))
      dispatch(
        getInfo({
          with: 'reservations,card,stateTransitions,cycleOrderPaid,latestOrderCanPay',
        }),
      )
      history.push(PATH_USER_DETAIL)
    } catch (error: any) {
      const status = error?.response?.status
      const errors = error?.response?.data.errors
      if (
        status === HTTP_CODE.UNPROCESSABLE_ENTITY &&
        Object.entries(errors).length > 0
      ) {
        errors &&
          Object.entries(errors).map((value) => {
            const getFieldName = get(value, 0)
            const getFieldValue = get(value, '1.0') || ''

            meta.setError(
              getFieldName as
                | 'postal_number'
                | 'prefecture_id'
                | 'city_id'
                | 'address'
                | 'building_name'
                | 'phone'
                | 'email',
              { type: 'custom', message: getFieldValue },
            )
          })
      } else {
        const message = error?.response?.data.message
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message: message,
          }),
        )
      }
      dispatch(addressActions.updateLoading(false))
    }
  },
)

export const verifyUser = createAsyncThunk<
  void,
  { phone?: string; email?: string; meta: UseFormReturn<any, any> }
>(
  'verify_user',
  async ({ phone, email, meta }, { dispatch, rejectWithValue }) => {
    try {
      await addressRequest.verifyUser({ phone, email })

      if (phone) meta.clearErrors('phone')
      if (email) meta.clearErrors('email')
    } catch (error: any) {
      const status = error?.response?.status
      const message =
        error?.response?.data?.message || 'この情報は既に使用されています。'

      if (phone) meta.setError('phone', { type: 'custom', message })
      if (email) meta.setError('email', { type: 'custom', message })

      if (status !== HTTP_CODE.UNPROCESSABLE_ENTITY) {
        dispatch(
          uiActions.onNotification({
            type: 'error',
            message,
          }),
        )
      }

      return rejectWithValue(message)
    }
  },
)
